import SVGS from "../../core/assets/svg";
import ROUTE_CONSTANT from "../../routes/routeconstants";
import Employment from "../../core/assets/images/employment.gif";
// import Board from "../../core/assets/images/fulfillment.gif";
import Home from "../../core/assets/images/homeTransparent.gif";
import ATS from "../../core/assets/images/ats.gif";
import Billing from "../../core/assets/images/billing.gif";
import Project from "../../core/assets/images/projects.gif";
import Profile from "../../core/assets/images/profile.gif";
import Reports from "../../core/assets/images/reports.gif";
import Payroll from "../../core/assets/images/payroll.gif";
import WorkFLow from "../../core/assets/images/workflow.gif";
import HR from "../../core/assets/images/hr.gif";
import Policies from "../../core/assets/images/policies.gif";
import Crm from "../../core/assets/images/crm.gif";
import StudentAts from "../../core/assets/images/studentAts.gif";
import AccountAndFinanace from "../../core/assets/images/accountAndFinanace.gif";
import StudentInformationSystem from "../../core/assets/images/sis.gif";
import Onboard from "../../core/assets/images/onboard.gif";
import LearningAndCourses from "../../core/assets/images/learningAndCourses.gif";
import Prospect from "../../core/assets/images/prospect.gif";
import Hospital from "../../core/assets/images/hospital.gif";
import Hierarchy from "../../core/assets/images/hierarchy.gif";
import Policy from "../../core/assets/images/policy.gif";
import FandFSettlement from "../../core/assets/images/f&fSettlement.gif";
import PayrollReports from "../../core/assets/images/payrollReports.gif";
import ViewPayroll from "../../core/assets/images/viewPayroll.gif";
import RunPayroll from "../../core/assets/images/runPayroll.gif";
import Budget from "../../core/assets/images/budget.gif";
import Approval from "../../core/assets/images/approval.gif";
import FaceCapture from "../../core/assets/images/faceCapture.gif";
import MyDetails from "../../core/assets/images/myDetails.gif";
import Board from "../../core/assets/images/board.gif";
import TaxInvoice from "../../core/assets/images/taxInvoice.gif";
import Invoice from "../../core/assets/images/invoice.gif";
import JobPerformance from "../../core/assets/images/jobPerformance.gif";
import InterviewPerformance from "../../core/assets/images/interviewPerformance.gif";
import ViewInterviewTemplate from "../../core/assets/images/viewInterviewTemplate.gif";
import InterviewTemplate from "../../core/assets/images/interviewTemplate.gif";
import InterviewSchedule from "../../core/assets/images/interviewSchedule.gif";
import ViewJobs from "../../core/assets/images/viewJobs.gif";

const {
  Asset,
  CreateClient,
  CreateJob,
  CreatePlacement,
  Finance,
  JobWise,
  ViewApplicant,
  ViewClient,
  ViewEmployee,
  ViewJob,
  ViewVendor,
  CreateVendor,
  RecruiterWise,
  ViewPlacement,
  CreateApplicant,
  Attendence,
  ClientWiseOrg,
  CreateProjectOrg,
  ViewProject,
  CreateSubVendor,
  ViewSubVendor,
  MyTime,
  Apperciatation,
  MyOrganzation,
  OfferLetter,
  Survey,
  Gratuity,
  Settlement,
  TimeSheet,
  ViewPerformance,
  Survey1,
  email,
  HolidayCalendar,
  Approval2,
} = SVGS;

const sideMenuData = [
  {
    id: 1,
    label: "Home",
    value: "Home",
    Icon: Home,
    to: ROUTE_CONSTANT.HOME,
    department: true,
  },
  // {
  //   id: 2,
  //   label: "ATS",
  //   value: "ATS",
  //   department: false,
  //   Icon: ATS,
  //   subgroup: [
  //     {
  //       label: "Create Job",
  //       to: ROUTE_CONSTANT.CREATE_JOB,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "View Job",
  //       to: ROUTE_CONSTANT.VIEW_JOBS,
  //       SubIcon: ViewJobs,
  //       access: false,
  //     },
  //     {
  //       label: "Create Applicant",
  //       to: ROUTE_CONSTANT.CREATE_APPLICANT,
  //       SubIcon: CreateApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "View Applicant",
  //       to: ROUTE_CONSTANT.VIEW_APPLICANT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Create Placement",
  //       to: ROUTE_CONSTANT.PLACEMENT,
  //       SubIcon: CreatePlacement,
  //       access: false,
  //     },
  //     {
  //       label: "View Placements",
  //       to: ROUTE_CONSTANT.VIEW_PLACEMENT,
  //       SubIcon: ViewPlacement,
  //       access: false,
  //     },
  //     {
  //       label: "Interview Schedule",
  //       to: ROUTE_CONSTANT.INTERVIEW_SCHEDULE,
  //       SubIcon: InterviewSchedule,
  //       access: false,
  //     },
  //     {
  //       label: "Scheduled Interviews",
  //       to: ROUTE_CONSTANT.SCHEDULED_INTERVIEWS,
  //       SubIcon: InterviewSchedule,
  //       access: false,
  //     },
  //     {
  //       label: "Interview Template",
  //       to: ROUTE_CONSTANT.INTERVIEW_TEMPLATE_CREATION,
  //       SubIcon: InterviewTemplate,
  //       access: false,
  //     },
  //     {
  //       label: "View Interview Templates",
  //       to: ROUTE_CONSTANT.VIEW_INTERVIEW_TEMPLATES,
  //       SubIcon: ViewInterviewTemplate,
  //       access: false,
  //     },
  //     {
  //       label: "Interview Performance",
  //       to: ROUTE_CONSTANT.INTERVIEW_PERFORMANCE,
  //       SubIcon: InterviewPerformance,
  //       access: false,
  //     },
  //     {
  //       label: "Job Wise Performance",
  //       to: ROUTE_CONSTANT.JOB_WISE_INTERVIEW_PERFORMANCE,
  //       SubIcon: JobPerformance,
  //       access: false,
  //     },
  //     {
  //       label: "Interview Assessment",
  //       to: ROUTE_CONSTANT.ASSESSMENT_TABS,
  //       SubIcon: JobPerformance,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   label: "Employment",
  //   value: "Employment",
  //   Icon: Employment,
  //   department: false,
  //   subgroup: [
  //     {
  //       label: "Employee",
  //       to: ROUTE_CONSTANT.VIEW_EMPLOYEE,
  //       SubIcon: ViewEmployee,
  //       access: false,
  //     },

  //     // {
  //     //   label: "Assets",
  //     //   to: ROUTE_CONSTANT.ASSET_TABS,
  //     //   SubIcon: Asset,
  //     //   access: false,
  //     // },
  //   ],
  // },
  // {
  //   id: 5,
  //   label: "Prospect",
  //   value: "Prospect",
  //   Icon: Prospect,
  //   department: false,
  //   subgroup: [
  //     {
  //       label: "Create Client",
  //       to: ROUTE_CONSTANT.CREATE_CLIENT,
  //       SubIcon: CreateClient,
  //       access: false,
  //     },
  //     {
  //       label: "View Client",
  //       to: ROUTE_CONSTANT.VIEW_CLIENT,
  //       SubIcon: ViewClient,
  //       access: false,
  //     },
  //     {
  //       label: "Create Vendor",
  //       to: ROUTE_CONSTANT.CREATE_VENDOR,
  //       SubIcon: CreateVendor,
  //       access: false,
  //     },
  //     {
  //       label: "View Vendor",
  //       to: ROUTE_CONSTANT.VIEW_VENDOR,
  //       SubIcon: ViewVendor,
  //       access: false,
  //     },
  //     {
  //       label: "Create Sub-Vendor",
  //       to: ROUTE_CONSTANT.CREATE_SUB_VENDOR,
  //       SubIcon: CreateSubVendor,
  //       access: false,
  //     },
  //     {
  //       label: "View Sub-Vendor",
  //       to: ROUTE_CONSTANT.VIEW_SUB_VENDOR,
  //       SubIcon: ViewSubVendor,
  //       access: false,
  //     },
  //     // {
  //     //   label: "Appraisal",
  //     //   to: ROUTE_CONSTANT.APPRAISAL,
  //     //   SubIcon: Appraisal,
  //     //   access: false,
  //     // },
  //   ],
  // },
  // {
  //   id: 6,
  //   label: "Billing",
  //   value: "Billing",
  //   department: false,
  //   Icon: Billing,
  //   subgroup: [
  //     {
  //       label: "Invoice",
  //       to: ROUTE_CONSTANT.INVOICE,
  //       SubIcon: Invoice,
  //       access: false,
  //     },
  //     {
  //       label: "Tax Invoice",
  //       to: ROUTE_CONSTANT.TAX_INVOICE,
  //       SubIcon: TaxInvoice,
  //       access: false,
  //     },

  //     {
  //       label: "Invoice Header Customizer",
  //       to: ROUTE_CONSTANT.INVOICE_HEADER_CUSTOMIZER,
  //       SubIcon: Invoice,
  //       access: false,
  //     },
  //     {
  //       label: "Invoice Product Quotation",
  //       to: ROUTE_CONSTANT.INVOICE_PRODUCT_QUOTATION_TABS,
  //       SubIcon: Invoice,
  //       access: false,
  //     },
  //     {
  //       label: "Timesheet",
  //       to: ROUTE_CONSTANT.EXPORT_TIME_SHEET,
  //       SubIcon: Invoice,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   label: "Project",
  //   value: "Project",
  //   Icon: Project,
  //   department: false,
  //   subgroup: [
  //     {
  //       label: "Board",
  //       to: ROUTE_CONSTANT.BLANK_BOARD,
  //       SubIcon: Board,
  //       access: false,
  //     },
  //     {
  //       label: "Create Project",
  //       to: ROUTE_CONSTANT.CREATE_PROJECT,
  //       SubIcon: CreateProjectOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View Project",
  //       to: ROUTE_CONSTANT.PROJECT_DETAILS,
  //       SubIcon: ViewProject,
  //       access: false,
  //     },
  //     {
  //       label: "Time Sheet",
  //       to: ROUTE_CONSTANT.TIME_SHEET,
  //       SubIcon: TimeSheet,
  //       access: false,
  //     },
  //   ],
  // },

  // {
  //   id: 9,
  //   label: "Reports",
  //   value: "Reports",
  //   department: false,
  //   Icon: Reports,
  //   subgroup: [
  //     {
  //       label: "Recruiter Wise",
  //       to: ROUTE_CONSTANT.RECRUITER_WISE,
  //       SubIcon: RecruiterWise,
  //       access: false,
  //     },
  //     {
  //       label: "Job Wise",
  //       to: ROUTE_CONSTANT.JOB_WISE,
  //       SubIcon: JobWise,
  //       access: false,
  //     },
  //     {
  //       label: "Client Wise",
  //       to: ROUTE_CONSTANT.CLIENT_WISE,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Attendance",
  //       to: ROUTE_CONSTANT.ATTENDENCE_REPORT,
  //       SubIcon: Attendence,
  //       access: false,
  //     },
  //     {
  //       label: "Budget",
  //       to: ROUTE_CONSTANT.BUDGET_REPORT,
  //       SubIcon: Budget,
  //       access: false,
  //     },
  //     {
  //       label: "Compensation",
  //       to: ROUTE_CONSTANT.COMPENSATION_REPORT,
  //       SubIcon: Budget,
  //       access: false,
  //     },
  //     {
  //       label: "Employee Live Location",
  //       to: ROUTE_CONSTANT.EMPLOYEE_LOCATION_MAP,
  //       SubIcon: Budget,
  //       access: false,
  //     },
  //     {
  //       label: "Employees",
  //       to: ROUTE_CONSTANT.EMPLOYEES_REPORTS,
  //       SubIcon: Budget,
  //       access: false,
  //     },
  //     {
  //       label: "Financial",
  //       to: ROUTE_CONSTANT.FINANCIAL_REPORTS,
  //       SubIcon: Budget,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 10,
  //   label: "Payroll",
  //   value: "Payroll",
  //   department: false,
  //   Icon: Payroll,
  //   subgroup: [
  //     {
  //       label: "Run payroll",
  //       to: ROUTE_CONSTANT.CREATE_PAYROLL,
  //       SubIcon: RunPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "View Payroll",
  //       to: ROUTE_CONSTANT.VIEW_PAYROLL,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Payroll Reports",
  //       to: ROUTE_CONSTANT.PAYROLL_REPORTS,
  //       SubIcon: PayrollReports,
  //       access: false,
  //     },
  //     {
  //       label: "Gratuity",
  //       to: ROUTE_CONSTANT.GRATUITY_TABS,
  //       SubIcon: Gratuity,
  //       access: false,
  //     },
  //     {
  //       label: "F & F Settlement",
  //       to: ROUTE_CONSTANT.SETTLEMENT_TABS,
  //       SubIcon: FandFSettlement,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 11,
  //   label: "Work Flow",
  //   value: "WorkFlow",
  //   department: false,
  //   Icon: WorkFLow,
  //   subgroup: [
  //     {
  //       label: "Policy",
  //       to: ROUTE_CONSTANT.POLICY_TAB,
  //       SubIcon: Policy,
  //       access: false,
  //     },
  //     {
  //       label: "Template",
  //       to: ROUTE_CONSTANT.TEMPLATE_TAB,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Hierarchy",
  //       to: ROUTE_CONSTANT.HIRERACHY,
  //       SubIcon: Hierarchy,
  //       access: false,
  //     },
  //     {
  //       label: "TimeLine",
  //       to: ROUTE_CONSTANT.TIME_LINE,
  //       SubIcon: Gratuity,
  //       access: false,
  //     },
  //     {
  //       label: "Approval Hierarchy",
  //       to: ROUTE_CONSTANT.APPROVAL_HIERACHY,
  //       SubIcon: Settlement,
  //       access: false,
  //     },
  //     {
  //       label: "Compensation SetUp",
  //       to: ROUTE_CONSTANT.COMPENSATION_SETUP,
  //       SubIcon: Settlement,
  //       access: false,
  //     },
  //     {
  //       label: "Map RFID",
  //       to: ROUTE_CONSTANT.MAP_RFID,
  //       SubIcon: Settlement,
  //       access: false,
  //     },
  //     {
  //       label: "Project Config",
  //       to: ROUTE_CONSTANT.PROJECT_CONFIG,
  //       SubIcon: Project,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 12,
  //   label: "Tools",
  //   value: "Tools",
  //   department: false,
  //   Icon: HR,
  //   subgroup: [
  //     {
  //       label: "HR Letter",
  //       to: ROUTE_CONSTANT.HR_LETTER_TAB,
  //       access: false,
  //       SubIcon: OfferLetter,
  //     },
  //     {
  //       label: "Approval Details",
  //       to: ROUTE_CONSTANT.APPROVAL_DETAILS,
  //       access: false,
  //       SubIcon: Approval2,
  //     },
  //     {
  //       label: "Create Survey",
  //       to: ROUTE_CONSTANT.SURVEY_TAB,
  //       access: false,
  //       SubIcon: Survey1,
  //     },
  //     {
  //       label: "Performance",
  //       to: ROUTE_CONSTANT.PERFORMANCE_TAB,
  //       access: false,
  //       SubIcon: Survey,
  //     },
  //     {
  //       label: "Email",
  //       to: ROUTE_CONSTANT.EMAIL,
  //       access: false,
  //       SubIcon: email,
  //     },
  //     {
  //       label: "Roaster Configuration",
  //       to: ROUTE_CONSTANT.ROASTER_CONFIG,
  //       access: false,
  //       SubIcon: Finance,
  //     },

  //     {
  //       label: "View Roaster Configuration",
  //       to: ROUTE_CONSTANT.VIEW_ROASTER_CONFIG,
  //       access: false,
  //       SubIcon: Finance,
  //     },

  //     {
  //       label: "Shift Configuration",
  //       to: ROUTE_CONSTANT.SHIFT_CONFIGURATION,
  //       SubIcon: HolidayCalendar,
  //       access: false,
  //     },

  //     {
  //       label: "Band",
  //       to: ROUTE_CONSTANT.BAND,
  //       SubIcon: Finance,
  //       access: false,
  //     },
  //     {
  //       label: "Resignation Reports",
  //       to: ROUTE_CONSTANT.RESIGNATION_REPORT,
  //       SubIcon: RecruiterWise,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 13,
  //   label: "Policies",
  //   value: "Policies",
  //   to: ROUTE_CONSTANT.POLICIES_LIST,
  //   department: false,
  //   Icon: Policies,
  // },
  // {
  //   id: 14,
  //   label: "CRM",
  //   value: "CRM",
  //   department: false,
  //   Icon: Crm,
  //   subgroup: [
  //     {
  //       label: "Create Crm Form",
  //       to: ROUTE_CONSTANT.CREATE_CRM_FORM,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "View Crm Forms",
  //       to: ROUTE_CONSTANT.VIEW_CRM_FORMS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create Crm Entries",
  //       to: ROUTE_CONSTANT.CREATE_CRM_ENTRIES,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "View Crm Entries",
  //       to: ROUTE_CONSTANT.VIEW_CRM_ENTRIES,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Crm DashBoard",
  //       to: ROUTE_CONSTANT.CRM_DASH_BOARD,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Crm TeamDashBoard",
  //       to: ROUTE_CONSTANT.CRM_TEAM_DASH_BOARD,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Enquiries",
  //       to: ROUTE_CONSTANT.VIEW_ENQUIRES,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create Contact",
  //       to: ROUTE_CONSTANT.CREATE_CONTACT_MANAGEMENT,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create Lead",
  //       to: ROUTE_CONSTANT.CREATE_LEAD,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Contacts",
  //       to: ROUTE_CONSTANT.VIEW_ALL_CONTACT_MANAGEMENT,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create Crm Base",
  //       to: ROUTE_CONSTANT.CREATE_CRM_BASE,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Base Leads",
  //       to: ROUTE_CONSTANT.BASE_LEADS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Leads",
  //       to: ROUTE_CONSTANT.LEADS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Sales Targets",
  //       to: ROUTE_CONSTANT.SALES_TARGETS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Sales Performance Reports",
  //       to: ROUTE_CONSTANT.SALES_PERFORMANCE_REPORTS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Sales Reports",
  //       to: ROUTE_CONSTANT.SALES_REPORTS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create Whatsapp Template",
  //       to: ROUTE_CONSTANT.CREATE_WHATSAPP_TEMPLATE,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //   ],
  // },
  // {
  //   id: 15,
  //   label: "Student ATS",
  //   value: "Student_ATS",
  //   department: false,
  //   Icon: StudentAts,
  //   subgroup: [
  //     {
  //       label: "Explore Courses",
  //       to: ROUTE_CONSTANT.COURSES_OVERVIEW,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },

  //     {
  //       label: "My Learning",
  //       to: ROUTE_CONSTANT.STUDENT_DASHBOARD,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "View Course",
  //       to: ROUTE_CONSTANT.VIEW_COURSE,
  //       SubIcon: ViewJob,
  //       access: false,
  //     },

  //     {
  //       label: "Create Student Applicant",
  //       to: ROUTE_CONSTANT.CREATE_STUDENT_APPLICANT,
  //       SubIcon: CreateApplicant,
  //       access: false,
  //     },

  //     {
  //       label: "View Student Applicants",
  //       to: ROUTE_CONSTANT.VIEW_STUDENT_APPLICANTS,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Assessment",
  //       to: ROUTE_CONSTANT.ASSESSMENT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Batch Wise Assessment",
  //       to: ROUTE_CONSTANT.BATCH_WISE_ASSESSMENT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "View Assessment",
  //       to: ROUTE_CONSTANT.VIEW_ASSESSMENT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "View Batch Wise Assessment",
  //       to: ROUTE_CONSTANT.VIEW_BATCH_WISE_ASSESSMENT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Rules And Regulations",
  //       to: ROUTE_CONSTANT.RULES_AND_REGULATIONS,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Start Assessment",
  //       to: ROUTE_CONSTANT.START_ASSESSMENT,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "View Response",
  //       to: ROUTE_CONSTANT.VIEW_RESPONSE,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "Create Batch",
  //       to: ROUTE_CONSTANT.CREATE_BATCH,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //     {
  //       label: "View Batch",
  //       to: ROUTE_CONSTANT.VIEW_BATCH,
  //       SubIcon: ViewApplicant,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 16,
  //   label: "Accounts and Finance",
  //   value: "Accounts_and_Finance",
  //   department: false,
  //   Icon: AccountAndFinanace,
  //   subgroup: [
  //     {
  //       label: "Payment Overview",
  //       to: ROUTE_CONSTANT.COURSE_PAYMENT_OVERVIEW,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "Payroll Configuration",
  //       to: ROUTE_CONSTANT.CREATE_PAYROLL_CONFIGURATION,
  //       SubIcon: RunPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "View Payroll Configuration",
  //       to: ROUTE_CONSTANT.VIEW_PAYROLL_TEMPLETE,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Account Creation",
  //       to: ROUTE_CONSTANT.ACCOUNT_CREATION,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Cash On Hand",
  //       to: ROUTE_CONSTANT.CASH_ON_HAND,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Bills",
  //       to: ROUTE_CONSTANT.BILLS,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Ledger Creation",
  //       to: ROUTE_CONSTANT.LEDGER_CREATION,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Create Vouchers",
  //       to: ROUTE_CONSTANT.CREATE_VOUCHERS,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Create Bank Statement",
  //       to: ROUTE_CONSTANT.CREATE_BANK_STATEMENT,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Create Tax Codes",
  //       to: ROUTE_CONSTANT.CREATE_TAX_CODES,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "View Tax Codes",
  //       to: ROUTE_CONSTANT.VIEW_TAX_CODES,

  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Create Journal Entries",
  //       to: ROUTE_CONSTANT.CREATE_JOURNAL_ENTRIES,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //     {
  //       label: "Inward Invoice",
  //       to: ROUTE_CONSTANT.INWARD_INVOICE,
  //       SubIcon: ViewPayroll,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 17,
  //   label: "Student Information System",
  //   value: "Student_Information_System",
  //   department: false,
  //   Icon: StudentInformationSystem,
  //   subgroup: [
  //     {
  //       label: "Student Onboarding",
  //       to: ROUTE_CONSTANT.STUDENT_ONBOARDING,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "View Students",
  //       to: ROUTE_CONSTANT.VIEW_STUDENTS,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "View Student",
  //       to: ROUTE_CONSTANT.VIEW_STUDENT,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //   ],
  // },

  // {
  //   id: 18,
  //   label: "OnBoarding",
  //   value: "OnBoarding",
  //   department: false,
  //   Icon: Onboard,

  //   subgroup: [
  //     {
  //       label: "Pre On Boarding",
  //       to: ROUTE_CONSTANT.VIEW_APPLICANT_ONBOARDINGLIST,
  //       access: false,
  //       SubIcon: ClientWiseOrg,
  //     },
  //   ],
  // },
  // {
  //   id: 19,
  //   label: "Learning and Courses",
  //   value: "Learning_And_Courses",
  //   department: false,
  //   Icon: LearningAndCourses,
  //   subgroup: [
  //     {
  //       label: "Create Course",
  //       to: ROUTE_CONSTANT.CREATE_COURSE,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "Explore Courses",
  //       to: ROUTE_CONSTANT.COURSES_OVERVIEW,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "My Learning",
  //       to: ROUTE_CONSTANT.STUDENT_DASHBOARD,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //     {
  //       label: "Course Progress",
  //       to: ROUTE_CONSTANT.COURSE_PROGRESS,
  //       SubIcon: CreateJob,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 20,
  //   label: "Asset Management",
  //   value: "Asset_Management",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Create Assets",
  //       to: ROUTE_CONSTANT.CREATE_ASSET,
  //       SubIcon: Asset,
  //       access: false,
  //     },
  //     {
  //       label: "View Assets",
  //       to: ROUTE_CONSTANT.VIEW_ASSET,
  //       SubIcon: Asset,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 21,
  //   label: "Inventory Management",
  //   value: "Inventory_Management",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Inventory Config",
  //       to: ROUTE_CONSTANT.INVENTORY_CONFIG,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Create Inventory",
  //       to: ROUTE_CONSTANT.CREATE_INVENTORY_MANAGEMENT,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View Inventory",
  //       to: ROUTE_CONSTANT.VIEW_INVENTORY_MANAGEMENT,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },

  //     {
  //       label: "Create Order",
  //       to: ROUTE_CONSTANT.CREATE_ORDER,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View Orders",
  //       to: ROUTE_CONSTANT.VIEW_ORDERS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Create Supplier",
  //       to: ROUTE_CONSTANT.CREATE_SUPPLIER,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View All Suppliers",
  //       to: ROUTE_CONSTANT.VIEW_ALL_SUPPLIERS,
  //       access: false,
  //       SubIcon: ClientWiseOrg,
  //     },
  //     {
  //       label: "Create Warehouse",
  //       to: ROUTE_CONSTANT.CREATE_WAREHOUSE,
  //       access: false,
  //       SubIcon: ClientWiseOrg,
  //     },
  //     {
  //       label: "View WareHouse",
  //       to: ROUTE_CONSTANT.VIEW_WAREHOUSE,
  //       access: false,
  //       SubIcon: ClientWiseOrg,
  //     },
  //     {
  //       label: "Product Catalog",
  //       to: ROUTE_CONSTANT.PRODUCT_CATALOG,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View Product Catalogs",
  //       to: ROUTE_CONSTANT.VIEW_PRODUCT_CATALOG,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Create Quotation",
  //       to: ROUTE_CONSTANT.CREATE_QUOTATION,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "View Quotations",
  //       to: ROUTE_CONSTANT.VIEW_PRODUCT_QUOTATION,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Create Price Lists",
  //       to: ROUTE_CONSTANT.CREATE_PRICE_LISTS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Enable Inventory Tracking",
  //       to: ROUTE_CONSTANT.ENABLE_INVENTORY_TRACKING,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Manage Inventory",
  //       to: ROUTE_CONSTANT.MANAGE_INVENTORY,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },

  // {
  //   id: 22,
  //   label: "Products",
  //   value: "Products",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "BizWrkDashBoard",
  //       to: ROUTE_CONSTANT.BIZWRKDASHBOARD,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Categories",
  //       to: ROUTE_CONSTANT.CATEGORIES,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Brands",
  //       to: ROUTE_CONSTANT.BRANDS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Warranties",
  //       to: ROUTE_CONSTANT.WARRANTIES,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },

  //     {
  //       label: "Variations",
  //       to: ROUTE_CONSTANT.VARIATIONS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "Units",
  //       to: ROUTE_CONSTANT.UNITS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     // {
  //     //   label: "Selling Price Groups",
  //     //   to: ROUTE_CONSTANT.SELLING_PRICE_GROUPS,
  //     //   SubIcon: ClientWiseOrg,
  //     //   access: false,
  //     // },
  //     // {
  //     //   label: "Import Opening Stock",
  //     //   to: ROUTE_CONSTANT.IMPORT_OPENING_STOCK,
  //     //   SubIcon: ClientWiseOrg,
  //     //   access: false,
  //     // },
  //     // {
  //     //   label: "Import Products",
  //     //   to: ROUTE_CONSTANT.IMPORT_PRODUCTS,
  //     //   SubIcon: ClientWiseOrg,
  //     //   access: false,
  //     // },
  //     {
  //       label: "Add Product",
  //       to: ROUTE_CONSTANT.ADD_PRODUCT,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "List Products",
  //       to: ROUTE_CONSTANT.LIST_PRODUCTS,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },

  // {
  //   id: 23,
  //   label: "Purchases",
  //   value: "Purchases",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Add Purchase",
  //       to: ROUTE_CONSTANT.ADD_PURCHASE,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "List Purchases",
  //       to: ROUTE_CONSTANT.LIST_PURCHASES,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "List Purchase Return",
  //       to: ROUTE_CONSTANT.LIST_PURCHAE_RETURN,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },

  // {
  //   id: 24,
  //   label: "Sell",
  //   value: "Sell",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Add Sells",
  //       to: ROUTE_CONSTANT.ADD_SALES,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "All Sells",
  //       to: ROUTE_CONSTANT.ALL_SALES,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "List Sell Return",
  //       to: ROUTE_CONSTANT.LIST_SELL_RETURN,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 25,
  //   label: "Location",
  //   value: "Location",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Business Location",
  //       to: ROUTE_CONSTANT.BUSINESS_LOCATION,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 26,
  //   label: "StockTransfer",
  //   value: "Stock_Transfer",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Add Stock Transfer",
  //       to: ROUTE_CONSTANT.ADD_STOCK_TRANSFER,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //     {
  //       label: "List Stock Transfer",
  //       to: ROUTE_CONSTANT.LIST_STOCK_TRANSFER,
  //       SubIcon: ClientWiseOrg,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 27,
  //   label: "Digital Marketing",
  //   value: "Digital_Marketing",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Org Keys",
  //       to: ROUTE_CONSTANT.ORG_KEYS,
  //       SubIcon: Finance,
  //       access: false,
  //     },
  //     {
  //       label: "Whatsapp Org Keys",
  //       to: ROUTE_CONSTANT.WHATSAPP_ORG_KEYS,
  //       SubIcon: Finance,
  //       access: false,
  //     },
  //   ],
  // },
  // {
  //   id: 28,
  //   label: "Biz Contacts",
  //   value: "Biz_Contacts",
  //   department: false,
  //   Icon: Board,
  //   subgroup: [
  //     {
  //       label: "Customers",
  //       to: ROUTE_CONSTANT.CUSTOMERS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Create BizContact",
  //       to: ROUTE_CONSTANT.CREATE_BIZ_CONTACT,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //     {
  //       label: "Suppliers",
  //       to: ROUTE_CONSTANT.SUPPLIERS,
  //       access: false,
  //       SubIcon: Finance,
  //     },
  //   ],
  // },



  {
    id: 8,
    label: "Profile",
    value: "Profile",
    Icon: Profile,
    department: false,
    subgroup: [
      {
        label: "My Details",
        to: ROUTE_CONSTANT.MY_PROFILE,
        SubIcon: MyDetails,
        access: false,
      },
      // {
      //   label: "Face Capture",
      //   to: ROUTE_CONSTANT.FACE_CAPTURE,
      //   SubIcon: FaceCapture,
      //   access: false,
      // },
      {
        label: "Approvals",
        to: ROUTE_CONSTANT.APPROVALS,
        SubIcon: MyDetails,
        access: false,
      },

    ],
  },
  {
    id: 33,
    label: "Temple and Seva Management",
    value: "Temple_and_Seva_Management",
    department: false,
    Icon: Board,
    subgroup: [
      {
        label: "Create Temple",
        to: ROUTE_CONSTANT.CREATE_TEMPLE_MASTER,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Temples",
        to: ROUTE_CONSTANT.VIEW_TEMPLE_MASTERS,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Create Seva Type",
        to: ROUTE_CONSTANT.CREATE_SEVA_TYPE,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Seva Types",
        to: ROUTE_CONSTANT.VIEW_SEVA_TYPES,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Schedule Seva",
        to: ROUTE_CONSTANT.SHEDULE_SEVA,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Scheduled Sevas",
        to: ROUTE_CONSTANT.VIEW_SEVA_SCHEDULES,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Create Donation Type",
        to: ROUTE_CONSTANT.DONATION_TYPE,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Donation Types",
        to: ROUTE_CONSTANT.VIEW_DONATION_TYPES,
        access: false,
        SubIcon: Finance,
      },
    ],
  },
  {
    id: 34,
    label: "Devotee",
    value: "Devotee",
    department: false,
    Icon: Board,
    subgroup: [
      {
        label: "Create Devotee",
        to: ROUTE_CONSTANT.CREATE_DEVOTEE,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Devotees",
        to: ROUTE_CONSTANT.VIEW_DEVOTEES,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Devotee Occasion",
        to: ROUTE_CONSTANT.DEVOTEE_OCCASION,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Devotee Occasions",
        to: ROUTE_CONSTANT.VIEW_DEVOTEE_OCCASIONS,
        access: false,
        SubIcon: Finance,
      },
    ],
  },
  {
    id: 35,
    label: "Donations",
    value: "Donations",
    department: false,
    Icon: Board,
    subgroup: [
      {
        label: "Create Donation",
        to: ROUTE_CONSTANT.CREATE_DONATIONS,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Donation",
        to: ROUTE_CONSTANT.VIEW_DONATIONS,
        access: false,
        SubIcon: Finance,
      },



    ],
  },
  {
    id: 36,
    label: "Booking",
    value: "Booking",
    department: false,
    Icon: Board,
    subgroup: [
      {
        label: "Create Voucher",
        to: ROUTE_CONSTANT.CREATE_VOUCHER,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Vouchers",
        to: ROUTE_CONSTANT.VIEW_VOCHERS,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Pooja Booking",
        to: ROUTE_CONSTANT.CREATE_POOJA_BOOKING,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "View Pooja Booking",
        to: ROUTE_CONSTANT.VIEW_POOJA_BOOKING,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Visista Seva Receipt",
        to: ROUTE_CONSTANT.CREATE_POOJA_RECEIPT,
        access: false,
        SubIcon: Finance,
      },

      {
        label: "View Receipts",
        to: ROUTE_CONSTANT.GET_ALL_RECEIPTS,
        access: false,
        SubIcon: Finance,
      },

    ],
  },

  {
    id: 37,
    label: "FinancialReports",
    value: "FinancialReports",
    department: false,
    Icon: Board,
    subgroup: [
      {
        label: "Daily Reports",
        to: ROUTE_CONSTANT.DAILY_RECEIPT,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Donor Reports",
        to: ROUTE_CONSTANT.DONOR_REPORT,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "BalanceSheet Reports",
        to: ROUTE_CONSTANT.BALANCESHEET_REPORTS,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "DevoteeBySevaType Reports",
        to: ROUTE_CONSTANT.DEVOTEE_BY_SEVATYPE_REPORTS,
        access: false,
        SubIcon: Finance,
      },
      {
        label: "Saswata AnnaPrsada Seva",
        to: ROUTE_CONSTANT.SASWATA_ANNAPRSADA_EXCEL,
        access: false,
        SubIcon: Finance,
      },


    ],
  },
  {
    id: 38,
    label: "Work Flow",
    value: "WorkFlow",
    department: false,
    Icon: WorkFLow,
    subgroup: [

      {
        label: "Approval Hierarchy",
        to: ROUTE_CONSTANT.APPROVAL_HIERACHY,
        SubIcon: Settlement,
        access: false,
      },
    ],
  },
];

export default sideMenuData;
